// Same-day ordering cut-off rules: 9:00 AM cut-off + 10 minute grace window (client local time, SA users)
export const CUTOFF_HOUR = 9;
export const GRACE_MINUTES = 10;

const minutesNow = (d = new Date()) => d.getHours() * 60 + d.getMinutes();

export const isWeekendDay = (d = new Date()) => d.getDay() === 0 || d.getDay() === 6;

// True strictly before 9:00 AM
export const isBeforeCutoff = (d = new Date()) => minutesNow(d) < CUTOFF_HOUR * 60;

// True between 9:00 and 9:10 — cut-off passed but the grace window still allows same-day orders
export const isInGraceWindow = (d = new Date()) => {
  const m = minutesNow(d);
  return m >= CUTOFF_HOUR * 60 && m < CUTOFF_HOUR * 60 + GRACE_MINUTES;
};

// Can the customer still place or change an order for TODAY?
export const canStillOrderToday = (d = new Date()) =>
  !isWeekendDay(d) && minutesNow(d) < CUTOFF_HOUR * 60 + GRACE_MINUTES;

// Minutes remaining until same-day ordering fully closes (9:10)
export const graceMinutesLeft = (d = new Date()) =>
  Math.max(0, CUTOFF_HOUR * 60 + GRACE_MINUTES - minutesNow(d));

export const nextBusinessDay = (from = new Date()) => {
  const t = new Date(from);
  t.setDate(t.getDate() + 1);
  while (t.getDay() === 0 || t.getDay() === 6) t.setDate(t.getDate() + 1);
  return t;
};
